import { render } from "./ContainerMenu.vue?vue&type=template&id=6207a9fa"
import script from "./ContainerMenu.vue?vue&type=script&lang=js"
export * from "./ContainerMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__